import jsonwebtoken from 'jsonwebtoken';

import IToken from '@/interfaces/Token';

export const tokenDecoder = (token: string): IToken|any => {
  return token && jsonwebtoken.decode(token);
};

export const tokenCreationDate = (token: string): Date|any => {
  const decodedToken = tokenDecoder(token);

  return decodedToken && new Date(decodedToken.iat * 1000).toUTCString();
};

export const tokenExpirationDate = (token: string): Date|any => {
  const decodedToken = tokenDecoder(token);

  return decodedToken && new Date(decodedToken.exp * 1000).toUTCString();
};

export const tokenExpiresIn = (token: string): number => {
  const currentDate = Date.now();
  const createdDate = tokenCreationDate(token).getTime();
  const expiresDate = tokenExpirationDate(token).getTime();

  const expiresIn = (currentDate > createdDate)
    ? expiresDate - createdDate
    : expiresDate - currentDate;

  return expiresIn > 0 ? expiresIn : 0;
};

export const tokenIsExpired = (token: string): any => {
  return token && !tokenExpiresIn(token);
};